export default __webpack_public_path__ + "static/media/ThumbsUp.65e2538f.svg";